
import template from './ps-parameter.html';
import Formula from './models.js';


class ComponentViewModel
{
	constructor(params)
	{
		this.parameter = params.param;
		this.depth = params.depth ?? 0;
		this.parameter_types = ko.observableArray(['formula','context','value']);
	}
}

export default {
	name: 'ps-parameter',
	viewModel: ComponentViewModel,
	module_type: 'ko',
	template: template
};

